import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchEmployeeListByName } from 'src/services/serviceinit.service';
import {
  getPassportCountryList,
  getEmployeeTypeList,
  getRelationshipStatusList,
  resetEmployee,
  resetDynamicContent,
  setInitiationValue,
} from '../state/serviceInitActions';
import AddApplicantPres from 'src/ui/features/ServiceInit/presentational/AddApplicantPres';
import { SI_ADD_APPLICANT_VIEWS } from 'src/constants/constants';
import { checkFields } from 'src/helpers';

class AddApplicantContainer extends React.Component {
  static propTypes = {
    /** Current selected engagement type */
    engagement: PropTypes.number,
    /** Current selected employee */
    employee: PropTypes.object,
    /** Any errors related to adding new applicants */
    error: PropTypes.object,
    /** Array containing all passport countries */
    passportCountryList: PropTypes.array,
    /** Array containing all relationship statuses */
    relationshipStatusList: PropTypes.array,
    /** Action to retrieve Passport country list for dropdown */
    getPassportCountryList: PropTypes.func.isRequired,
    /** Action to retrieve Employee Type list for dropdown */
    getEmployeeTypeList: PropTypes.func.isRequired,
    /** Action to retrieve Relationship status list for dropdown */
    getRelationshipStatusList: PropTypes.func.isRequired,
    /** Action to reset dynamic content and menu */
    resetDynamicContent: PropTypes.func.isRequired,
    /** Action to set values in addInitiation object */
    setInitiationValue: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      isMenuOpen: false,
      passportCountry: '',
      ...(this.props.employee ? this.props.employee : {}),
    };
  }

  componentDidMount() {
    const { getPassportCountryList, getEmployeeTypeList, getRelationshipStatusList } = this.props;
    getPassportCountryList();
    getRelationshipStatusList();
    getEmployeeTypeList();
  }

  setValue = (field, value) => {
    this.setState({ [field]: value }, () => {
      const { isMenuOpen, ...formData } = this.state;
      const isFormFilled = this.checkFormFilled();

      this.props.setInitiationValue('employee', formData, true);
      this.props.setInitiationValue('addApplicantViewType', SI_ADD_APPLICANT_VIEWS.ADDNEW, isFormFilled);
    });
  };

  onSearch = val => {
    const engagementId = this.props.engagement;
    return fetchEmployeeListByName(val, engagementId, 100).then(result => {
      const sourceData = result && result.messages && result.messages.slice(0, 100);
      const data = sourceData.map((row, index) => ({ ...row, index }));
      return { options: data, complete: true };
    });
  };

  onEmployeeSelect = employee => {
    // changing the employee forces a brand new create showorganizer to be generated
    if (employee === null) {
      this.props.resetEmployee();
      this.props.resetDynamicContent(true);
      return;
    }
    this.props.setInitiationValue('employee', employee);
  };

  checkFormFilled = () => {
    const { isMenuOpen, ...employeeData } = this.state;
    const requiredFields = ['firstName', 'lastName', 'emailAddress', 'dateOfBirth', 'contactNumber', 'relationshipStatus', 'employeeCode'];

    const isFilled = checkFields(employeeData, requiredFields);
    return isFilled;
  };

  handleChangeView = status => {
    if (status === 'open') {
      this.props.setInitiationValue('addApplicantViewType', SI_ADD_APPLICANT_VIEWS.ADDNEW, false);
      this.setState(
        {
          dateOfBirth: '',
          email: '',
          employeeId: '',
          employeeName: '',
          engagement: '',
          location: '',
          passportCountry: '',
        },
        () => this.props.resetEmployee(),
      );
    } else {
      this.props.setInitiationValue('addApplicantViewType', SI_ADD_APPLICANT_VIEWS.SEARCH, false);
    }
  };

  render() {
    return (
      <AddApplicantPres
        onSearch={this.onSearch}
        onEmployeeSelect={this.onEmployeeSelect}
        setValue={this.setValue}
        changeEmployeeView={this.handleChangeView}
        {...this.state}
        {...this.props}
      />
    );
  }
}

const mapStateToProps = ({ serviceInit }) => ({
  menu: serviceInit.addInitiation.menu,
  currentMenuPage: serviceInit.addInitiation.currentMenuPage,
  passportCountryList: serviceInit.passportCountryList,
  engagement: serviceInit.addInitiation.engagement,
  employee: serviceInit.addInitiation.employee,
  error: serviceInit.addInitiation.error,
  employeeTypeList: serviceInit.employeeTypeList,
  relationshipStatusList: serviceInit.relationshipStatusList,
  addApplicantViewType: serviceInit.addInitiation.addApplicantViewType,
});

const mapDispatchToProps = {
  getPassportCountryList,
  getEmployeeTypeList,
  getRelationshipStatusList,
  resetEmployee,
  resetDynamicContent,
  setInitiationValue,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddApplicantContainer);



// WEBPACK FOOTER //
// ./src/ui/features/ServiceInit/containers/AddApplicantContainer.js